import React from 'react';

import { useLocation } from 'react-router';

import { TripEventWebViewType } from './constants';

export const useWebViewLinksHandler = () => {
  const { search } = useLocation();

  function observeLinkChangesInDOM() {
    const targetNode = document.body;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const links = document.querySelectorAll('[data-external-link]');

          const linksArray = Array.from(links) as HTMLAnchorElement[];
          linksArray.forEach((link) => {
            if (link.hasAttribute('data-url')) return; // handled by injectedJS in the app //TODO: remove after update app
            if (!link.href.includes('https')) return;
            link.onclick = (e) => {
              e.preventDefault();
              // @ts-ignore
              window?.ReactNativeWebView?.postMessage?.(
                JSON.stringify({ type: TripEventWebViewType.openLink, url: link.href }),
              );
            };
          });
        }
      });
    });

    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
    };
  }

  React.useEffect(() => {
    if (new URLSearchParams(search).get('webview') !== 'true') return;
    observeLinkChangesInDOM();
  }, []);
};
